import { format } from 'date-fns';
import chunk from 'lodash/chunk';
import map from 'lodash/map';
import { DATE_FORMAT, DEFAULT_DATE_FORMAT } from './constants';
import { DatePickerMode } from './types';
const getMonths = () => map(new Array(12), (item, index) => ({
    monthLabel: format(new Date(2000, index), DATE_FORMAT.MMM),
    monthIndex: index,
}));
export const getGroupedMonths = (amount) => chunk(getMonths(), amount);
export const formatDateFromRange = (dateFromRange) => dateFromRange ? format(dateFromRange, DEFAULT_DATE_FORMAT) : '';
export const getInputMask = (datepickerMode) => datepickerMode === DatePickerMode.SINGLE ? '00/00/0000' : '00/00/0000 - 00/00/0000';
export const formatCalendarDate = (date) => {
    if (date === undefined) {
        return '';
    }
    if (date instanceof Date) {
        return format(date, DEFAULT_DATE_FORMAT);
    }
    return `${date?.from && format(date?.from, DEFAULT_DATE_FORMAT)} - ${date?.to && format(date?.to, DEFAULT_DATE_FORMAT)}`;
};
